import * as React from 'react';
import {connect} from 'react-redux';
import {Route, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {App} from '../app/index';
import type {NutshellState} from '../store';

import {RefreshingPage} from './refreshing-page';

type OwnProps = JSX.LibraryManagedAttributes<typeof Route, React.ComponentProps<typeof Route>>;

type StateProps = {
    appVersion: string | null | undefined;
};
type RoutedProps = OwnProps & ContextRouter;
type Props = RoutedProps & StateProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        appVersion: App.getAppVersion(state),
    };
}

const RefreshingRouteComponent = (props: Props) => {
    const {appVersion, render, ...routeProps} = props;

    if (!render) return null;

    // Note: We get the remote app vresion from our notification count
    // endpoint for performance. See NotificationController.php and
    // notification-bell-button.tsx for more details.
    const newVersionAvailable = Boolean(
        appVersion &&
            NutshellFrontendSettings.appVersion &&
            appVersion !== NutshellFrontendSettings.appVersion
    );

    return (
        <Route
            {...routeProps}
            render={(renderProps) => (
                <RefreshingPage
                    pathname={routeProps.location.pathname}
                    shouldRefresh={newVersionAvailable}
                >
                    {render(renderProps)}
                </RefreshingPage>
            )}
        />
    );
};

// @ts-expect-error
const connector = connect<Props, RoutedProps, _, _, _, _>(
    mapStateToProps,
    null,
    null,
    // Need to liberally re-render, because its direct props don't often change, but the parent's does.
    {pure: false}
);
// @ts-expect-error
export const RefreshingRoute = withRouter<OwnProps>(connector(RefreshingRouteComponent));
